module.exports = __webpack_public_path__ + "img/pearlescentmoon-cf2c312d-72ae-40cc-568a-08d969423842.png";